import swal from 'sweetalert';

/**
 * Set global so you don't have to import it
 */
window.swal = swal;
